// Auto-generated file - DO NOT EDIT
// This file is generated by scripts/generate-liveupdate-channel.ts
// Run: npm run generate-channel

export const LIVEUPDATE_CHANNEL = 'production-v2.9.0';
